<template>
	<div :style="{ height: show ? 'auto' : '100%' }">
		<com-back name="Confirmar el préstamo" :tip="1"></com-back>
		<div class="wrapper">
			<div class="main_flex">
				<div class="center">
					<div class="title">Monto de préstamo ($)</div>
					<span class="number">
						{{ addComma(calculateData.borrowAmount) }}
					</span>
				</div>
				<div class="center">
					<div class="title">Plazo (días)</div>
					<span class="number">
						{{ addComma(calculateData.period) }}
					</span>
				</div>
			</div>
			<com-coupon :couponData="couponData" @confirmarEmit="confirmarEmit"></com-coupon>
			<div class="bottom">
				<div class="bottom_main">
					<span>Fecha de pago</span>
					<span>{{ calculateData.firstRepayDateFormat }}</span>
				</div>
				<div class="bottom_main">
					<span>Pago total</span>
					<span
						:style="
							calculateData.totalRepayAmountOld != calculateData.totalRepayAmount ? 'text-decoration:line-through' : ''
						"
					>
						$ {{ addComma(calculateData.totalRepayAmountOld) }}
					</span>
					<span style="font-weight:600" v-if="calculateData.totalRepayAmountOld != calculateData.totalRepayAmount">
						&nbsp;$ {{ addComma(calculateData.totalRepayAmount) }}
					</span>
				</div>
				<div class="bottom_main" @click="handleBanca">
					<span>Cuenta bancaria</span>
					<div class="banca">
						<span>{{
							calculateData.bankNo ? calculateData.bankNo.replace(/^(\d{4})\d+(\d{4})$/, '$1****$2') : ''
						}}</span>
						<img src="@/assets/image/internal/payment/right.png" alt="" class="right_img" />
					</div>
				</div>

				<div class="bottom_main" @click="handleShow">
					<span>Detalles de intereses</span>
					<img src="@/assets/image/internal/payment/top.png" alt="" v-if="show" />
					<img src="@/assets/image/internal/payment/bottom.png" alt="" v-else />
				</div>
			</div>
			<div class="bottom fee_select" v-if="show">
				<div class="bottom_main">
					<span>Monto depositado</span>
					<span>
						<span
							:style="
								calculateData.borrowAmountOld != calculateData.borrowAmount ? 'text-decoration: line-through;' : ''
							"
						>
							$ {{ addComma(calculateData.borrowAmountOld) }}
						</span>
						<span v-if="calculateData.borrowAmountOld != calculateData.borrowAmount">
							&nbsp;$ {{ addComma(calculateData.borrowAmount) }}
						</span>
					</span>
				</div>

				<div class="bottom_main">
					<span>Tarifa de servicio Cloud</span>
					<span>
						<span style="text-decoration: line-through;">$ 30,000</span>
						$ {{ addComma(calculateData.totalServiceFee) }}
					</span>
				</div>
				<!-- <div class="bottom_main">
          <span>IVA</span>
          <span>$ {{ addComma(calculateData.totalGst) }}</span>
        </div> -->
				<div class="bottom_main">
					<span>Interés@25% e.a</span>
					<span>$ {{ addComma(calculateData.totalInterest) }}</span>
				</div>
			</div>
			<swipe-info :bannerList="bannerList" style="margin-top:.2rem"></swipe-info>

			<div class="bottomFixed">
				<div class="select">
					<img src="@/assets/image/internal/select.webp" alt="" @click="handleSelect" v-if="select" />
					<img src="@/assets/image/internal/select_no.webp" alt="" @click="handleSelect" v-else />
					<span
						>He leído y acepto el
						<span style="text-decoration: underline;" @click="gotoLoanAgree">contrato de préstamo.</span>
					</span>
				</div>
				<van-button class="wrapper_button" @click="handleContinuar">
					MODIFICAR
				</van-button>
			</div>
			<van-overlay :show="loading">
				<div class="dialog_wrapper" @click.stop>
					<van-loading size="50" />
				</div>
			</van-overlay>
		</div>
	</div>
</template>

<script>
	import common from '@/mixins/common.js'
	import comCoupon from '@/components/internal/coupon'
	import { addComma } from '@/utils/internal'
	import comBack from '@/components/internal/back.vue'
	import swipeInfo from '@/components/internal/swipeInfo.vue'
	import Bus from '@/utils/bus'
	export default {
		mixins: [common],
		components: {
			comCoupon,
			comBack,
			swipeInfo,
		},
		data() {
			return {
				show: false,
				select: false,
				calculateData: {
					bankNo: '',
				},
				loan_info: {},
				selectedRadio: '',
				confirCouponType: null,
				couponData: {},
				confirmarObjectValue: {},
				loading: false,
				bannerList: [],
			}
		},
		created() {
			Bus.$on('change-bank', (args) => {
				this.calculateData.bankNo = args
				//...
			})
		},
		mounted() {
			this.getAccessToken()
			this.getApiHead()
			this.refreshPage()
			window.android.hideTitle()
		},
		methods: {
			addComma,
			refreshPage() {
				this.getCalculate()
				this.getLoanInfo()
				this.getGetBanner({ bannerType: 10 })
			},
			//获取确认后的优惠券数据
			confirmarEmit(value) {
				this.confirmarObjectValue = value
			},
			gotoLoanAgree() {
				window.android.gotoLoanAgree()
			},
			handleShow() {
				this.show = !this.show
			},
			handleSelect() {
				this.select = !this.select
			},
			//Trial
			getCalculate(radio) {
				this.$axios
					.post(this.apiHeadGatewayVh + 'calculate', {
						...this.params,
						accountCouponId: radio ? radio : -1,
					})
					.then((res) => {
						if (res.data.code == 0) {
							if (JSON.parse(res.data.data).code == 'SUCCESS') {
								this.calculateData = JSON.parse(res.data.data).data
								this.getCoupon()
							} else {
								this.$toast(JSON.parse(res.data.data).codeDesc)
							}
						}
					})
			},
			//Jump to the bank card modification page
			handleBanca() {
				// window.android.openUrl(`${this.url}/banca?mobile=${this.calculateData.mobile}`)
				// window.open(`http://localhost:8080/banca?mobile=${this.calculateData.mobile}`)
				this.$router.push({
					path: 'banca',
					query: {
						mobile: this.calculateData.mobile,
					},
				})
			},
			//Click to confirm
			handleContinuar() {
				// console.log(
				//   this.confirmarObjectValue.confirmarId
				//     ? this.confirmarObjectValue.confirmarId?.toString()
				//     : "0"
				// );
				if (!this.select) {
					return this.$toast('Confirme el contrato de préstamo.')
				}
				this.loading = true
				window.android.orderConfirm(
					this.confirmarObjectValue.confirmarId ? this.confirmarObjectValue.confirmarId?.toString() : '0',
					'0',
				)
				this.loading = false
			},
		},
		beforeRouteLeave(to, from, next) {
			// 清除 sessionStorage 缓存
			sessionStorage.clear()
			// 继续导航到下一个路由
			next()
		},
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/internal/payment/calculation.scss';
	@import '@/assets/style/internal/toast.scss';
</style>
